import React from 'react';
import { token } from '@atlaskit/tokens';
import { FormattedMessage } from 'react-intl';

import { messages } from 'modules/mac/messages';
import Tooltip from 'components/common/Tooltip';
import { StyledParagraphWithTextAlign, StyledGreyParagraph } from '../../styledComponents';

export const MakePrimaryTooltip: React.FC = () => (
  <Tooltip
    direction="up-middle"
    content={
      <StyledParagraphWithTextAlign $textAlign="center">
        <FormattedMessage {...messages.inactiveMakePrimary} />
      </StyledParagraphWithTextAlign>
    }
  >
    <StyledGreyParagraph $greyShade={token('color.text.subtle', '#44546F')}>
      <FormattedMessage {...messages.makePrimary} />
    </StyledGreyParagraph>
  </Tooltip>
);
